
// const Base_Uri = "https://api.solutionplus.online/api/";
// const Image_Uri = "https://api.solutionplus.online/src/";
// const SOCKET_URI = "https://api.solutionplus.online";
// const Base_Uri = "https://betaapi.solutionplus.online/api/";
// const Image_Uri = "https://betaapi.solutionplus.online/src/";
// const SOCKET_URI = "https://betaapi.solutionplus.online";
// const Base_Uri = "http://192.168.100.71:5000/api/"
// const Image_Uri = "http://192.168.100.71:5000/src/"
// const SOCKET_URI = "http://localhost:5000"

const Base_Uri = "https://api.dashboard.mobiletechnicians.online/api/";
const Image_Uri = "https://api.dashboard.mobiletechnicians.online/src/";
const SOCKET_URI = "https://api.dashboard.mobiletechnicians.online";

export { Base_Uri, Image_Uri,SOCKET_URI };

//52515.98
